import { subheadline } from '@/shared/styles/colors';
import React from 'react';
import { Image } from 'react-native';

export const DateAndTimeIcon = () => {
  return (
    <Image
      source={require('@/assets/images/AvailabilitySmIcon.png')}
      style={{
        width: 20,
        height: 20,
        marginRight: 8,
        resizeMode: 'contain',
      }}
      tintColor={subheadline}
    />
  );
};

export const DurationIcon = () => {
  return (
    <Image
      source={require('@/assets/images/Duration.png')}
      style={{ width: 14, height: 15, marginRight: 5 }}
      tintColor={subheadline}
    />
  );
};

export const ReasonIcon = () => {
  return (
    <Image
      source={require('@/assets/images/HangerIcon.png')}
      tintColor={subheadline}
      style={{ width: 18, height: 13, marginRight: 5 }}
    />
  );
};

export const StylistIcon = () => {
  return (
    <Image
      source={require('@/assets/images/Stylist.png')}
      style={{ width: 14, height: 16, marginRight: 4 }}
      tintColor={subheadline}
    />
  );
};

export const StarIcon = () => {
  return (
    <Image
      source={require('@/assets/images/Star.png')}
      style={{ width: 13, height: 13, marginRight: 4 }}
      tintColor={subheadline}
    />
  );
};

export const InPersonIcon = () => {
  return (
    <Image
      source={require('@/assets/images/InPerson.png')}
      style={{
        width: 15,
        height: 15,
        marginRight: 8,
        resizeMode: 'contain',
      }}
      tintColor={subheadline}
    />
  );
};

export const VirtualIcon = () => {
  return (
    <Image
      source={require('@/assets/images/Virtual.png')}
      style={{ width: 20, height: 14, resizeMode: 'contain', marginRight: 4 }}
      tintColor={subheadline}
    />
  );
};
